import Actions from '../actions/actions';
import { featureFlagsCRUDActions } from '../actions/FeatureFlagsCRUDActions';
import { setBusy, setUnBusy } from './common/commonReducers';
import {
  SubscriptionFeatureFlag,
  FeaturesForPlans,
} from '../controllers/FeatureFlags';

export const featureFlagsInitialState = {
  subscriptionFeatureFlags: [] as SubscriptionFeatureFlag[],
  featuresForPlans: {} as FeaturesForPlans,
  busy: false,
};

type FeatureFlagsState = typeof featureFlagsInitialState;

type RetrievedAction = {
  type: string;
  entity: SubscriptionFeatureFlag[];
};

export type RetrievedFeaturesForPlansAction = {
  type: string;
  featuresForPlans: SubscriptionFeatureFlag[];
};

const retreived = (state: FeatureFlagsState, action: RetrievedAction) => {
  return { ...state, subscriptionFeatureFlags: action.entity, busy: false };
};

const retreivedFeatureForPlans = (
  state: FeatureFlagsState,
  action: RetrievedFeaturesForPlansAction,
) => {
  return { ...state, featuresForPlans: action.featuresForPlans, busy: false };
};

export const featureFlags = (state = featureFlagsInitialState, action: any) => {
  switch (action.type) {
    case featureFlagsCRUDActions.busyAction:
      return setBusy(state);
    case featureFlagsCRUDActions.unbusyAction:
      return setUnBusy(state);
    case featureFlagsCRUDActions.retrievedAction:
      return retreived(state, action);
    case featureFlagsCRUDActions.retrievedFeaturesForPlansAction:
      return retreivedFeatureForPlans(state, action);
    case Actions.RESET:
      return featureFlagsInitialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
};
